import VueCookie from "vue-cookie"

export default {
  install (Vue) {
    Vue.prototype.$cookie = VueCookie
  }
}